import React, { memo } from 'react'
import { faCheckCircle, faTimesCircle } from '@fortawesome/pro-light-svg-icons'
import { useTranslation } from 'react-i18next'

import {
  BW_COLOR_ACCENT,
  BW_COLOR_ERROR
} from 'src/libs/qb-brand-web-components'
import Popup from '../../shared/popup/Popup'

const EmailChangeConfirmation = ({ success, error, onSubmit }) => {
  const { t } = useTranslation()
  const params = success
    ? {
        title: t('message.email-address-changed'),
        description: t('message.email-address-changed-desc'),
        icon: faCheckCircle,
        color: BW_COLOR_ACCENT
      }
    : {
        title: t('message.failed-to-change-email'),
        description: t(error),
        icon: faTimesCircle,
        color: BW_COLOR_ERROR
      }
  return (
    <Popup
      {...params}
      submitLabel={t('common.close')}
      onFormSubmit={onSubmit}
    />
  )
}

export default memo(EmailChangeConfirmation)
